export default {
  es: {
    user: 'Guía del usuario',
    doc: 'Documentación',
    api: 'Configuración técnica',
    userBtnTxt: 'Ver manual de usuario',
    docBtnTxt: 'Ver documentación',
    apiBtnTxt: 'Ver documentación API',
    productsTitle: 'Productos disponibles',
    headingTitle: 'Centro de documentación',
    apiHlpTxt: 'Métodos de autenticación, componentes y documentación del contrato.',
    userHlpTxt: 'Paso a paso para conocer cada página del producto y cómo utilizarlo.',
    docHlpTxt: 'Descripción general del producto: ¿Qué es RiskScore?, ¿Cómo funciona?, Configuración técnica, etc.',
    truauth: 'Una solución Plug & Play para autenticación y autorización telefónica multifactor sin fricciones utilizando infraestructura de nivel de operador.',
    riskScore: 'RiskScore es un producto de verificación de la suite TruScore que permite rastrear y monitorear el comportamiento de líneas telefónicas o direcciones IP.',
    mnv: 'MNV es un producto de autenticación de la suite TruAuth que permite verificar si el operador conoce un número de móvil mediante autenticación de datos interna.',
    truscore: 'Un modelo estadístico basado en inteligencia artificial y aprendizaje automático en tiempo real para detectar y evaluar el comportamiento telefónico de los consumidores asociado con un número de teléfono móvil o una dirección IP de los consumidores.',
    introduction: `
      ¡Bienvenido al centro de documentación de TruSense!
      </br></br>Aquí encontrarás documentación general de cada producto, información técnica y manuales de usuario para conectar y utilizar correctamente los servicios de nuestras soluciones: TruScore, TruAuth y TruIDV.
    `,
  },
  en: {
    user: 'User guide',
    doc: 'Documentation',
    api: 'Technical setup',
    userBtnTxt: 'View user manual',
    docBtnTxt: 'View documentation',
    apiBtnTxt: 'View API documentation',
    productsTitle: 'Available products',
    headingTitle: 'Documentation center',
    apiHlpTxt: 'Authentication methods, components and contract documentation.',
    userHlpTxt: 'Step by step to know each page of the product and how to use it.',
    docHlpTxt: 'General description about product: What is %{product}?, How does this work?, Technical setup, etc.',
    truauth: 'A Plug & Play solution for frictionless multi-factor telephone authentication and authorization using carrier-grade infrastructure.',
    riskScore: '',
    mnv: 'MNV is an authentication product of the TruAuth suite that allows to verify if a mobile number is known by the operator through internal data authentication.',
    truscore: 'TruScore helps in gauging the trustworthiness of the mobile number and the IP address by assesing and analyzing their behavioural aspect. This information helps enterprises to take a data driven decision either during onboarding a customer or during an ongoing transation.',
    introduction: `
      Welcome to the TruSense documentation center! 
      </br></br>Here you will find general documentation on each product, technical information and user manuals to connect and use the services of our solutions correctly: TruScore, TruAuth and TruIDV.    
    `,
  },
};
